import * as React from "react";
import type { SATimelinePhase, SASectionCopy } from "@/data/sellerAnalysisTypes";
import { Reveal, Overline } from "@/components/presentation/primitives";

interface Props {
  timeline: SATimelinePhase[];
  intro?: SASectionCopy;
}

export const SA_Timeline: React.FC<Props> = ({ timeline, intro }) => {
  if (!timeline?.length) return null;

  return (
    <section
      className="w-full bg-ivory py-20 md:py-28"
      data-testid="sa-timeline"
      aria-label="Launch plan"
    >
      <div className="mx-auto w-full max-w-5xl px-6 md:px-10">
        <Reveal>
          <Overline>{intro?.overline || "The first 14 days"}</Overline>
          <h2 className="mt-4 max-w-2xl font-serif text-3xl leading-tight text-charcoal md:text-4xl">
            {intro?.headline || "The opening two weeks, planned."}
          </h2>
        </Reveal>

        <Reveal delay={0.05}>
          <ol className="mt-14 grid grid-cols-1 gap-y-8 sm:grid-cols-2 lg:grid-cols-5 lg:gap-x-4">
            {timeline.map((phase, i) => (
              <li key={i} className="lg:pr-4">
                <div className="flex items-center gap-3 lg:block">
                  <span className="font-serif text-lg text-brass">{phase.number}</span>
                  <div className="mt-0 hidden h-px w-full bg-charcoal/15 lg:mt-4 lg:block" />
                </div>
                <h3 className="mt-2 text-sm font-medium uppercase tracking-[0.16em] text-charcoal lg:mt-4">
                  {phase.label}
                </h3>
                {phase.detail && (
                  <p className="mt-2 text-sm leading-relaxed text-charcoal-soft">
                    {phase.detail}
                  </p>
                )}
              </li>
            ))}
          </ol>
        </Reveal>
      </div>
    </section>
  );
};
